export { PageContainerShape as default } from "./PageContainerShape-styles";
